import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

type SidepanelFooterProps = ComponentProps<'div'>

// Bottom chrome in document flow. The composer owns this box's height while
// the floating toolbar remains absolutely positioned above it.
export function SidepanelFooter({ className, ...props }: SidepanelFooterProps) {
  return <div className={twMerge('pointer-events-none relative flex shrink-0 flex-col gap-2', className)} {...props} />
}
